/* SG Beauty Extensions — minimal progressive-enhancement JS */
(function () {
  'use strict';

  /* Scroll reveal */
  function initReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.sg-reveal:not(.is-in)');
    // In the theme editor (design mode) or without IO support, reveal immediately.
    // This prevents a section from looking blank when the editor re-renders it.
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Mobile nav */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    drawer.querySelectorAll('[data-nav-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Sticky header shadow */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Product gallery thumbnails */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main] img');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { window.sgReady = true; initReveal(); initNav(); initHeader(); initGallery(); });

  /* Theme editor: when a section is re-rendered or added, re-run its per-section
     init. Without this, freshly injected .sg-reveal elements stay at opacity:0
     and the section looks blank until you save (full reload). */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initGallery(e.target);
    initHeader();
  });
  document.addEventListener('shopify:section:select', function (e) { initReveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target) { e.target.classList.add('is-in'); initReveal(e.target); }
  });
})();
